// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  vendorsDetails: Object,
};

const Deletevendor = (props: Props) => {
  const {
    visible,
    close,
    submit,
    vendorsDetails,
  } = props;

  const DeleteVendor = () => {
    submit(vendorsDetails.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={DeleteVendor} type="danger">Delete</SpButton>,
      ]}
      title="Delete Contact"
    >
      <div className="px-4">
        <div className="mt-1 mb-2">Are you sure you want to delete this contact?</div>
        <SpH5 className="pb-3">
          <div>{vendorsDetails.name || <>&#8211;</>}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default Deletevendor;
